import { GtmTracker } from '@/modules/common/services/analytics';
import { BankAccountField } from './types';

const trackAmplitudeEvent = GtmTracker.trackerWithDefaultProps({
  page_screen: 'deposit',
  digital_experience: 'investor',
  experience_section: 'home'
});

export function trackDepositModalOpening() {
  trackAmplitudeEvent({
    event_type: 'load',
    event_name: 'view'
  });
}

const CopyEventNameMapper = {
  [BankAccountField.Name]: 'copy_cardholder_name',
  [BankAccountField.Agency]: 'copy_agency_number',
  [BankAccountField.Account]: 'copy_account_number'
};

export function trackDepositByTED(field: BankAccountField) {
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'deposit_ted',
    event_name: CopyEventNameMapper[field]
  });
}
